import { Button, Modal, Typography } from 'antd';
import React, { createContext, ReactNode, useState } from 'react';
import { logout } from '~/utils/auth';

export type SessionExpiredModalContextValue = {
  openModalFn: () => void;
};
export const SessionExpiredModalContext =
  createContext<SessionExpiredModalContextValue>({
    openModalFn: () => {},
  });

const SessionExpiredModalProvider = ({ children }: { children: ReactNode }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = () => {
    setModalOpen(true);
  };
  const handleClickOk = () => {
    setModalOpen(false);
    logout();
  };

  return (
    <SessionExpiredModalContext.Provider
      value={{
        openModalFn: openModal,
      }}
    >
      {children}
      <Modal
        centered
        footer={[
          <Button key="ok" onClick={handleClickOk} type="primary">
            OK
          </Button>,
        ]}
        onOk={() => setModalOpen(false)}
        title="Session Expired"
        visible={modalOpen}
      >
        <Typography.Text>
          Your session is expired. Please re-login!
        </Typography.Text>
      </Modal>
    </SessionExpiredModalContext.Provider>
  );
};

export default SessionExpiredModalProvider;
